<div class="page-innder-body portlet light">
  <div class="portlet-body">
    <!-- Top Action Bar -->
    <div class="top-action-bar">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div class="d-flex align-items-center gap-2">
          <span class="page-title">{{ 'galleryRequestedProduct.requestedProducts' | transloco }}</span>
          @if (totalRequestedProduct > 0) {
            <span class="count-badge">{{totalRequestedProduct}}</span>
          }
        </div>
        <div class="d-flex align-items-center gap-2">
          <p-button type="button" icon="fa fa-clock-o" iconPos="left" [outlined]="true" severity="success"
          class="p-button-sm" [label]="'galleryRequestedProduct.showHistory' | transloco" (click)="showHistoryDialog()"></p-button>
        </div>
      </div>
    </div>
    <!-- Filters -->
    <div class="filters-container">
      <div class="d-flex flex-wrap gap-2 align-items-center">
        <div class="form-group flex-fill" style="min-width: 150px;">
          <p-dropdown [options]="connectedArtists" [(ngModel)]="artistId" name="selectedArtistId"
            (onChange)="onArtistChanged($event)" [filter]="true" [showClear]="true" [filterBy]="'label'"
            [optionLabel]="'label'" [optionValue]="'value'" [placeholder]="'galleryRequestedProduct.filterByArtist' | transloco">
          </p-dropdown>
        </div>
        <div class="form-group flex-fill" style="min-width: 150px;">
          <p-dropdown [options]="statusFilterOptions" [filter]="true" [showClear]="true" inputId="statusFilter"
            name="statusFilter" [placeholder]="'galleryRequestedProduct.filterByStatus' | transloco" [(ngModel)]="filters.RequestStatus"
          (onChange)="onStatusFilterChange($event)"></p-dropdown>
        </div>
        <div class="form-group flex-fill" style="min-width: 150px;">
          <input type="text" [(ngModel)]="searchText" (input)="FilterByProductName()" [placeholder]="'galleryRequestedProduct.search' | transloco"
            class="form-control">
          </div>
          <div class="form-group">
            <p-button type="button" icon="pi pi-times" iconPos="left" [outlined]="true" severity="secondary"
            (click)="clearAllFilters($event)" class="p-button-sm" [label]="'galleryRequestedProduct.clearAll' | transloco"></p-button>
          </div>
        </div>
      </div>
      <!-- Skeleton Loader -->
      @if (isLoading) {
        <div class="row my-2">
          @for (placeholder of [1,2,3,4,5,6]; track placeholder) {
            <div class="col-4 mt-3">
              <div class="skeleton-card">
                <div class="skeleton-image"></div>
                <div class="skeleton-details">
                  <div class="skeleton-text skeleton-title"></div>
                  <div class="skeleton-text skeleton-line"></div>
                  <div class="skeleton-text skeleton-line short"></div>
                  <div class="skeleton-text skeleton-line"></div>
                </div>
              </div>
            </div>
          }
          <div class="col-12 text-center text-muted small mt-3">
            <i class="pi pi-spin pi-spinner me-2"></i> {{ 'galleryRequestedProduct.loadingProducts' | transloco }}
          </div>
        </div>
      }
      @if (requestedProducts && requestedProducts.length > 0) {
        <ds-artwork-grid context="gallery-requested-products" #rg class="d-block my-2">
          @for (product of requestedProducts; track product) {
            <ds-artwork-card
              [size]="rg.size"
              [imageUrl]="product.ProductImgUrl"
              [name]="product.ProductName"
              [artist]="product.ArtistName"
              [subtitle]="product.RequestedDate | date:'dd MMM yyyy'"
              [price]="product.ArtistRevenue"
              [priceLabel]="'galleryRequestedProduct.artistRevenue' | transloco"
              [status]="product.IsProductRejected ? ('galleryRequestedProduct.declined' | transloco) : (product.IsProductAccepted ? ('galleryRequestedProduct.accepted' | transloco) : ('galleryRequestedProduct.pending' | transloco))"
              [statusTone]="product.IsProductRejected ? 'declined' : (product.IsProductAccepted ? 'available' : 'pending')"
              (cardClick)="goToProductDetails(product)"></ds-artwork-card>
          }
        </ds-artwork-grid>
      }
        <!-- No products found message -->
        @if (requestedProducts.length === 0) {
          <div class="row my-2">
            <div class="col-12 text-center">{{ 'galleryRequestedProduct.noProductsFound' | transloco }}</div>
          </div>
        }
      </div>
    </div>

    <p-dialog [header]="'galleryRequestedProduct.historyManagement' | transloco" [(visible)]="productRequestHistoryVisible" [modal]="true"
      [style]="{'width': '530px' }">
      <p-table [value]="history" [rowHover]="true" styleClass="p-datatable-gridlines p-datatable-striped"
        [paginator]="history.length > 10? true: false" [rows]="10" [reorderableColumns]="true" [resizableColumns]="false">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'galleryRequestedProduct.productName' | transloco }}</th>
            <th>{{ 'galleryRequestedProduct.productRequestHistory' | transloco }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-historyItem>
          <tr>
            <td>{{ historyItem.ProductName }}</td>
            <td>
              <div>{{ historyItem.Message }}</div>
              <div class="text-muted small">{{ historyItem.ArtistName }} | {{ historyItem.ActionDate | date: 'dd-MMM-yyyy'
              }}</div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="2">
              <div class="text-center">{{ 'galleryRequestedProduct.noLogsFound' | transloco }}</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-dialog>